<template>
    <section class="product-block" v-if="products && products.length > 0">
        <div class="product-block__container">
            <div class="product-block__body">
                <div class="product-block__top top-block">
                    <NuxtLink :to="{ name: 'catalog-categoryId', params: { categoryId: slug ?? '0' } }" class="top-block__title title">{{ title }}</NuxtLink>
                    <div class="product-block__navigation navigation navigation_slider">
                        <button :class="{ navigation__btn: true, 'btn-prev': true, [`prev-${id}`]: true }" @click="prevSlide"></button>
                        <button :class="{ navigation__btn: true, 'btn-next': true, [`next-${id}`]: true }" @click="nextSlide"></button>
                    </div>
                </div>
                <swiper
                    class="product-slider"
                    :modules="modules"
                    :observer="true"
                    :observeParents="true"
                    :speed="300"
                    :scrollbar="{
                        draggable: true,
                    }"
                    :mousewheel="{
                        forceToAxis: true,
                    }"
                    :navigation="{
                        prevEl: `.product-block__navigation .prev-${id}`,
                        nextEl: `.product-block__navigation .next-${id}`,
                    }"
                    :breakpoints="swiperOptions.breakpoints">
                    <swiper-slide v-for="(product, index) in localProducts" :key="index"><ProductCart :product="product" /></swiper-slide>
                </swiper>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Scrollbar, Navigation, Mousewheel } from "swiper";
import ProductCart from "./ProductCart.vue";
import "swiper/css";

const props = defineProps({
    id: Number,
    title: String,
    slug: String,
    categoryId: {
        type: Number,
        required: true,
    },
    products: {
        type: Array,
        default: () => [],
    },
});

const config = useRuntimeConfig();
const apiUrl = config.public.apiUrl;

const localProducts = ref([...props.products]);

const swiperOptions = {
    breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 15 },
        767: { slidesPerView: 2.5, spaceBetween: 25 },
        991: { slidesPerView: 3, spaceBetween: 35 },
        1270: { slidesPerView: 4, spaceBetween: 50 },
    },
};

const modules = [Scrollbar, Navigation, Mousewheel];

const loadProducts = async (id) => {
    try {
        const response = await $fetch(`${apiUrl}home/products`);
        // Теперь API возвращает структуру где данные разбиты по ID секций
        localProducts.value = response[id]?.data || [];
    } catch (error) {
        console.error(error);
        localProducts.value = [];
    }
};

watch(
    () => props.products,
    (newVal) => {
        localProducts.value = [...newVal];
    },
    { immediate: true },
);

watch(
    () => props.id,
    (newVal) => {
        if (localProducts.value.length === 0) {
            loadProducts(newVal);
        }
    },
    { immediate: true },
);

onMounted(() => {
    if (localProducts.value.length === 0) {
        loadProducts(props.id);
    }
});
</script>

<style></style>
